export const CONTRACT_ATTACHMENT_CONFIG = {
	acceptedExtensions: [
		'.pdf',
		'.png',
		'.jpg',
		'.jpeg',
		'.webp',
		'.txt',
		'.md',
		'.csv',
		'.json',
		'.xml',
		'.html',
		'.doc',
		'.docx',
		'.xls',
		'.xlsx',
	],
	maxSizeBytes: Number('15728640'),
} as const;
